import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["enableSmoothScroll"];
import React from 'react';
import PropTypes from 'prop-types';
import DefaultCarousel from './DefaultCarousel';
import SmoothScrollCarousel from './SmoothScrollCarousel';
const CarouselWrapper = _ref => {
  let {
      enableSmoothScroll
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  if (enableSmoothScroll) return /*#__PURE__*/React.createElement(SmoothScrollCarousel, props);
  return /*#__PURE__*/React.createElement(DefaultCarousel, props);
};
CarouselWrapper.propTypes = {
  enableSmoothScroll: PropTypes.bool
};
CarouselWrapper.defaultProps = {
  enableSmoothScroll: false
};
export default CarouselWrapper;
//# sourceMappingURL=CarouselWrapper.js.map